import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import noRows from '../../images/no-rows.png';

const useStyles = makeStyles(theme => ({
    overlayContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        padding: '20px',
        color: '#FFF',
    },
    image: {
        width: '132px',    // Set fixed width to 132px
        height: '132px',   // Set fixed height to 132px
        objectFit: 'contain', // Maintain aspect ratio and fit inside the box
        maxWidth: '300px',
        minWidth: '100px',
    },
    message: {
        color: theme.palette.text.primary,
        fontSize: '20px',
        textAlign: 'center',
        width: '550px',  // This width will now be respected
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        display: 'block',
        lineHeight: '1.5',
    },
}));

const NoresultsOverlay = (props) => {
    const classes = useStyles();

    return (
        <Grid
            container
            className={classes.overlayContainer}
        >
            <Grid
                container xs={12} justifyContent='center' alignItems='center'
            >
                <Grid item>
                    <img src={noRows} alt="No Results" className={classes.image} />
                    <div className={classes.message}>
                        {props.message}
                    </div>

                </Grid>

            </Grid>
        </Grid>
    );
};

NoresultsOverlay.propTypes = {
    message: PropTypes.string,
};

export default NoresultsOverlay;
